import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import GameSwitcher from './shared/components/GameSwitcher';
import ZipApp from './games/zip/App';
import NeonApp from './games/neon/App';
import JellyApp from './games/jelly/App';
import './shared/base.css';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<GameSwitcher />} />
        <Route path="/zip/*" element={<ZipApp />} />
        <Route path="/neon/*" element={<NeonApp />} />
        <Route path="/jelly/*" element={<JellyApp />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
